/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import type { SnippetsSectionProps } from '../Snippets/types';
import { Text } from './Text';
import { SnippetsSection } from '../Snippets/SnippetsSection';
import { Link } from '@mui/material';
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader';
import { SECTION_NAME_DOCUMENTATION } from '../../../constants/snippetsSectionNames';

const DOCS_URL = 'https://ckeditor.com/docs/ckeditor5/latest/getting-started/index.html';

export function Documentation( { number, isLoading }: SnippetsSectionProps ): ReactNode {
	return (
		<SkeletonLoader number={ number } sectionTitle={ SECTION_NAME_DOCUMENTATION } isLoading={ isLoading }>
			<SnippetsSection headerCharacter={ number } title={ SECTION_NAME_DOCUMENTATION }>
				<Text>
					Congratulations on setting up CKEditor! To make the most of it, visit
					the <Link href={ DOCS_URL } target='_blank'>CKEditor documentation</Link> for comprehensive guidance on how
					to fully customize and integrate the editor.
				</Text>
			</SnippetsSection>
		</SkeletonLoader>
	);
}
